import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  icon: {
    width: 15,
    height: 15,
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.primary.dark,
    },

    '&.info': {
      color: theme.palette.info.dark,

      '&:hover': {
        color: theme.palette.info.darkest,
      },
    },
  },
}))

export default useStyles
